import { ErrorMessage, useMessageService } from 'framework/ui/Message';
import { useRecruitmentApi } from 'infrastructure/api';
import { Stages } from './applicationPipeline';

const useCandidateApplicationPipelineService = () => {
  const { sendPostRequest } = useRecruitmentApi();
  const { addMessage } = useMessageService();

  const moveApplicationOfCandidate = async (
    candidateId: StringOrNumber,
    moveToStageName: Stages,
    payload: any = null,
  ) => {
    try {
      const res = await sendPostRequest(`/candidates/applications/${candidateId}/pipeline/move`, {
        targetStage: moveToStageName,
        payload,
      });
      const resJson = await res.json();
      return resJson;
    } catch (error: any) {
      const errorJson = await error.json();
      if (errorJson.message) {
        addMessage(new ErrorMessage(errorJson.message));
      }
      return false;
    }
  };

  return {
    moveApplicationOfCandidate,
  };
};

export default useCandidateApplicationPipelineService;
